function ShowActionsConstructor() {
  const responseObject = {
    notify_me: false,
    enquire_now: false,
    add_to_cart: false,
    engrave: false,
    requires_personalisation: false,
    requires_personalisation_inline: false,
    variants: false
  };

  const universalChecks = (product, outOfStock) => {

    if (product?.shopify_metafields?.engraving?.available) {
      Object.assign(responseObject, {
        add_to_cart: true,
        engrave: true
      });
    }

    if (product.shopify_metafields.coming_soon) {
      Object.assign(responseObject, {
        add_to_cart: false,
        engrave: false,
        requires_personalisation: false,
        notify_me: true
      });
    }

    if (product.shopify_metafields.enquire_now) {
      Object.assign(responseObject, {
        add_to_cart: false,
        engrave: false,
        requires_personalisation: false,
        enquire_now: true
      });
    }
    if (product.shopify_metafields.buyable_enquire_now) {
      Object.assign(responseObject, {
        add_to_cart: true,
        engrave: false,
        requires_personalisation: false,
        enquire_now: true
      });
    }
  };

  const b2b = (product, outOfStock, callback = undefined) => {
    if (!outOfStock) {
      responseObject.add_to_cart = true;
    }
    universalChecks(product, outOfStock);

    if (product.shopify_metafields.requires_personalisation) {
      Object.assign(responseObject, {
        add_to_cart: false,
        requires_personalisation: !outOfStock,
        requires_personalisation_inline: false
      });
    }

    if (!product.shopify_metafields.allowed_for_b2b) {
      responseObject.add_to_cart = false;
    }

    if (outOfStock) {
      responseObject.add_to_cart = false;
      if (product.shopify_metafields.notify_me_block) {
        responseObject.notify_me = true;
      }
    }
    if (typeof callback === 'function') {
      callback(responseObject);
    }
  };

  const b2c = (product, outOfStock, callback = undefined) => {
    if (!outOfStock) {
      responseObject.add_to_cart = true;
    }

    if (product.shopify_metafields.requires_personalisation) {
      Object.assign(responseObject, {
        add_to_cart: false,
        requires_personalisation: !outOfStock,
        requires_personalisation_inline: false
      });
    }

    universalChecks(product, outOfStock);

    if (!product.shopify_metafields.allowed_for_b2c) {
      responseObject.add_to_cart = false;
    }
    if (outOfStock) {
      responseObject.add_to_cart = false;
      if (product.shopify_metafields.notify_me_block) {
        responseObject.notify_me = true;
      }
    }
    if (typeof callback === 'function') {
      callback(responseObject);
    }
  };

  const sort = (type) => {
    if (type === 'b2b') {
      return b2b;
    }
    return b2c;
  };

  return {
    sort,
    b2b,
    b2c
  };
}

// eslint-disable-next-line func-names
const showActions = (function () {
  const instance = new ShowActionsConstructor();
  return {
    getInstance: () => instance
  };
})();

export default showActions;
